import { onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export const SEARCH_MAX_LENGTH = 200;

export const useKeywordSearchQuery = () => {
  const route = useRoute();
  const router = useRouter();

  const query = ref('');

  watch(
    () => route.query,
    () => {
      query.value =
        typeof route.query.query === 'string' ? route.query.query : '';
    },
  );

  onMounted(() => {
    if (route.query.query && typeof route.query.query === 'string') {
      query.value = route.query.query;
    }
  });

  const search = () => {
    if (query.value === route.query.query) return;
    if (!query.value || query.value.trim() === '') return;
    const nextPageName =
      route.meta.type === 'search' ? route.name ?? 'searchAll' : 'searchAll';
    router.push({
      name: nextPageName,
      query: { ...route.query, query: query.value },
    });
  };

  const clear = () => {
    query.value = '';
  };

  return { query, search, clear };
};
